import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Title,
  CategoryScale,
  registerables,
} from 'chart.js';
import { MarketState } from 'store/modules/market_store/types';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';

const BarChartGraphic = () => {
  ChartJS.register(ArcElement, Tooltip, Title, CategoryScale, ...registerables);

  const { market } = useSelector<ApplicationState, MarketState>((state) => state.session.market);

  const labels = market?.date_range.map((val) => val.x);
  const data = {
    labels,
    responsive: true,
    datasets: [
      {
        label: 'Licitações',
        data: market?.date_range.map((val) => val.y),
        borderColor: 'rgb(33, 37, 41)',
        backgroundColor: 'rgb(149, 108, 202)',
        yAxisID: 'y',
        position: 'left',
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      y: {
        display: true,
        position: 'left' as const,
      },
    },
  };
  return (
    <div className="card p-3">
      <Bar data={data} options={options} height={100} />
    </div>
  );
};

export default BarChartGraphic;
